import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabCargo = '/service/contabilidade/administracaoRH/'

class CargoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getCargo() {
        return this.conex.get(urlTabCargo + 'retornaTodosCargo/')
    }
}

export default CargoService
